import common = require("../../common");
import SearchBox = require("../../core/SearchBox");
import HotEditableFormManager = require("./hotEditable/HotEditableFormManager");
import Vue from 'vue';
import Component from 'vue-class-component';
import SharedHotEditableParentForm = require("./hotEditable/SharedHotEditableParentForm");
import HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader");
import HotEditableDoubleSelectsComponent = require("./hotEditable/HotEditableDoubleSelectsComponent");
import { PopupStates } from "../../common";
import HotEditableCheckboxComponent = require("./hotEditable/HotEditableCheckboxComponent");
import utilities = require("../utilities");

//declare function require(name: string): any;

//var jsUtilities = require('../../js/jsUtilities');
//var jsClasses = require('../../js/jsClasses');

// The @Component decorator indicates the class is a Vue component
@Component
class SearchBoxHeaderVue extends Vue implements common.IHotEditableFormParentVue {
    searchBox: SearchBox;
    initialData: any;
    actions: common.ISearchBoxAction[];
    autoCloseFiltersOnButtoClick: boolean;
    openFiltersOnInit: boolean;
    displayFilters = false;
    hasFilters = false;
    hasActiveFilters = false;
    _isMounted = false;
    _currentSearchParameter: common.ISearchParameters;
    _onAction = null as (type: common.ToolsBarActionTypes, selectionRule: common.ToolsBarSelectionRules, confirmationTitleHtml: string, confirmationMessageHtml: string, isCtlClick: boolean) => void;
    _onSelectAllAction = null as () => void;
    _onUnelectAllAction = null as () => void;
    _filtersUpdateCallback = null as (hasActiveFilters: boolean) => void;
    _onFilterButtonClick = null as () => void;
    _mountedCallback = null as () => void;
    _termsBoxFieldName: string;
    _initialFilters = null as common.ISearchBoxFilter[];

    shared: SharedHotEditableParentForm;
    formMode = common.HotEditableFormModes.original;
    formManager: HotEditableFormManager;

    beforeCreate() {
        HotEditableFormLoader.loadComponentsFromParent(this);

        this.searchBox = (this.initialData as common.ISearchBoxHeaderInitialData).searchBox;
        this.openFiltersOnInit = (this.initialData as common.ISearchBoxHeaderInitialData).openFiltersOnInit;
        this.$options.el = (this.initialData as common.ISearchBoxHeaderInitialData).el;
        const actions = (this.initialData as common.ISearchBoxResultsInitialData).actions;
        this.actions = [];
        // Activer par defaut les actions (sera refactorise lors du rework des QuickActions dynamiques).
        for (let i = 0; i < (actions || []).length; i++) {
            const a = actions[i];
            a.isEnable = true;
            this.actions.push(a);
        }

        this.formManager = new HotEditableFormManager(this, (this.initialData as common.ISearchBoxHeaderInitialData).formName);
        this.shared = new SharedHotEditableParentForm(this.formManager);
    }

    created() {
    }

    mounted() {
        this._termsBoxFieldName = "TermsBox";

        this._isMounted = true;

        if (this._mountedCallback) {
            this._mountedCallback();
            this._mountedCallback = null;
        }

        if (this.openFiltersOnInit)
            this.openFilters();
    }

    /** Retournera TRUE si au moins un filtre a ete modifie */
    setFilters(filters: common.ISearchBoxFilter[]) {
        filters = filters || [];
        var isModified = false;
        for (let i = 0; i < filters.length; i++) {
            const f = filters[i];
            if (f && f.name) {
                this.shared.updateField(f.name, f.value);
                isModified = true;
            }
        }
        return isModified;
    }

    setTerms(value: string) {
        this.shared.updateField(this._termsBoxFieldName, value || '');
    }

    isAutoCloseFiltersOnButtoClick() {
        return this.autoCloseFiltersOnButtoClick === true;//Default is FALSE
    }

    setAutoCloseFiltersOnButtoClick(value?: boolean) {
        this.autoCloseFiltersOnButtoClick = value !== false;// default is TRUE
        return this.autoCloseFiltersOnButtoClick;
    }

    setFiltersUpdateCallback(action: (isActive: boolean) => void) {
        if (!action)
            throw "L'argument 'action' est requis et ne doit pas etre NULL.";

        this._filtersUpdateCallback = action;

        return this;
    }

    displayReinitButton() {
        return !utilities.isEmptySearchParametersFilters({ filters: this.searchBox.defaultSearchFilters } as common.ISearchParameters);
    }

    updateFiltersFromSearchParameters(searchParameters: common.ISearchParameters) {

        this._currentSearchParameter = searchParameters;

        if (this._isMounted) {
            this.innerUpdateFiltersFromSearchParameters(searchParameters);
            return;
        }

        this._mountedCallback = () => {
            this.innerUpdateFiltersFromSearchParameters(searchParameters);
        };
    }
    private innerUpdateFiltersFromSearchParameters(searchParameters: common.ISearchParameters) {
        this.formManager.clearAllFields([this._termsBoxFieldName]);

        const filters = searchParameters.filters || [];
        var hasActiveFilters = false;
        if (filters.length) {
            for (let i = 0; i < filters.length; i++) {
                const filter = filters[i];
                const field = this.formManager.getFieldByName(filter.fieldName);

                if (!field)
                    continue;

                if (field.elementName === this._termsBoxFieldName)
                    continue;

                const value = filter.values
                    ? (filter.values.length ? filter.values[0] : "")
                    : "";

                field.setFromTextualValue(value);

                if (hasActiveFilters)
                    continue;

                if (field.isHidden && field.isHidden())
                    continue;

                const isReadonly = !field.canChangeEditMode && !field.editModeOn;

                if (isReadonly || field.disabled)
                    continue;

                if (!value || !value.length || value === HotEditableDoubleSelectsComponent.defaultValue() || value === HotEditableCheckboxComponent.defaultValue())
                    continue;

                hasActiveFilters = true;
            }

            this.hasFilters = true;
        } else {
            this.hasFilters = false;
        }

        if (this._filtersUpdateCallback)
            this._filtersUpdateCallback(hasActiveFilters);
    }

    updateSearchParametersFromFilters(searchParameters: common.ISearchParameters) {
        const filters = [] as common.ISearchFilter[];
        const fields = this.formManager.getFields();

        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];

            if (field.elementName === this._termsBoxFieldName)
                continue;

            const value = field.getTextualValue();
            const newFilter = {
                fieldName: field.elementName,
                values: [value]
            } as common.ISearchFilter;

            filters.push(newFilter);
        }

        searchParameters.filters = filters;

        return searchParameters;
    }

    onFiltersCloserButtonClick(e: Event) {
        this.closeFilters();
    }

    openFilters() {
        return this.toggleFilters(PopupStates.opened);
    }

    closeFilters() {
        return this.toggleFilters(PopupStates.closed);
    }

    toggleFilters(forcedState?: PopupStates) {

        forcedState = forcedState || PopupStates.unknown;

        if (forcedState === PopupStates.unknown)
            // toggle
            this.displayFilters = !this.displayFilters;
        else
            // forced
            this.displayFilters = forcedState === PopupStates.opened;

        return this;
    }

    setHeaderAtions(actions: common.ISearchBoxAction[]) {

        // activer par defaut les actions.
        for (let i = 0; i < (actions || []).length; i++)
            actions[i].isEnable = true;

        this.actions = actions;

        this.updateHeaderActions();

        return this;
    }

    onActionClick(event: KeyboardEvent, action: common.ISearchBoxAction) {
        const isCtlClick = utilities.isCtlKeyPressed(event);
        this.actionClick(action, isCtlClick);
    }

    setOnAction(action: (type: common.ToolsBarActionTypes, selectionRule: common.ToolsBarSelectionRules, confirmationTitleHtml: string, confirmationMessageHtml: string, isCtlClick: boolean) => void) {
        this._onAction = action;
        return this;
    }
    setOnSelectAllActionClick(action: () => void) {
        this._onSelectAllAction = action;
        return this;
    }
    setOnUnelectAllActionClick(action: () => void) {
        this._onUnelectAllAction = action;
        return this;
    }

    onSelectAllAction() {
        if (this._onSelectAllAction)
            this._onSelectAllAction();
        return this;
    }

    onUnelectAllAction() {
        if (this._onUnelectAllAction)
            this._onUnelectAllAction();
        return this;
    }

    onAction(type: common.ToolsBarActionTypes, selectionRule: common.ToolsBarSelectionRules, confirmationTitleHtml: string, confirmationMessageHtml: string, isCtlClick: boolean) {
        if (this._onAction)
            this._onAction(type, selectionRule, confirmationTitleHtml, confirmationMessageHtml, isCtlClick);
        return this;
    }

    countEnabledActions() {
        var cpt = 0;
        for (let i = 0; i < (this.actions || []).length; i++) {
            const a = this.actions[i];
            if (a.isVisible)
                cpt++;
        }
        return cpt;
    }

    updateHeaderActions(updatedActions?: common.IToolsBarUpdatedAction[], selectedItems?: common.ISelectedItem[]) {
        selectedItems = selectedItems || [];


        for (let i = 0; i < (this.actions || []).length; i++) {
            const a = this.actions[i];

            if (updatedActions) {
                const updatedAction = this.isUpdatedAction(updatedActions, a.type);
                if (updatedAction && a.isVisible !== updatedAction.isVisible)
                    //this.$set(a, 'isVisible', updatedAction.isVisble);
                    a.isVisible = updatedAction.isVisible;
            }

            // if (a.type === common.ToolsBarActionTypes.selectAll) {
            //     var newTitle: string;
            //     if (this.allItemsAreLoaded()) {
            //         newTitle = "Cocher tout";
            //     } else {
            //         const n = this.estimateLoadedItems();
            //         const t = this.getTotalResults();
            //         newTitle = ("Cocher {n} de {t}" as any)
            //             .replace("{n}", n)
            //             .replace("{t}", t);
            //     }
            //     a.title = newTitle;
            // }
        }
    }

    private isUpdatedAction(updatedActions: common.IToolsBarUpdatedAction[], actionType: common.ToolsBarActionTypes) {
        for (let i = 0; i < updatedActions.length; i++) {
            const a = updatedActions[i];
            if (actionType === a.type)
                return a;
        }
        return null as common.IToolsBarUpdatedAction;
    }

    private actionClick(action: common.ISearchBoxAction, isCtlClick: boolean) {
        isCtlClick = isCtlClick === true;

        if (action.type === common.ToolsBarActionTypes.selectAll) {
            this.onSelectAllAction();
            return;
        }

        if (action.type === common.ToolsBarActionTypes.unselectAll) {
            this.onUnelectAllAction();
            return;
        }

        this.onAction(action.type, action.selectionRule, action.confirmationTitleHtml, action.confirmationMessageHtml, isCtlClick);
    }
    setOnFilterButtonClick(action: () => void) {
        this._onFilterButtonClick = action || null;
        return this;
    }

    onFilterButtonClick(event: Event) {
        if (this._onFilterButtonClick)
            this._onFilterButtonClick();
    }

    updateFitlersButtonStatus(isActive: boolean) {
        this.hasActiveFilters = isActive;
        return this;
    }

    updateTermsFromSearchParameters(searchParameters: common.ISearchParameters) {

        const orginalsTerms = searchParameters.originalTerms;


        const field = this.getTermsBox();

        if (field) {
            field.setFromTextualValue(orginalsTerms);
        }

        return this;
    }

    onClearTermsButtonClick(event: Event) {
        this.clearTermsBox()
    }

    clearTermsBox() {
        const field = this.getTermsBox();
        if (field)
            field.clear();
        return field || null;
    }

    getOriginalTerms() {
        return this.getTermsBox().getTextualValue();
    }

    updateSearchParametersFromTerms(originalTerms: string, searchParameters: common.ISearchParameters) {

        searchParameters.originalTerms = originalTerms || '';
        searchParameters.terms = [];

        return searchParameters;
    }

    private getTermsBox() {
        return this.formManager.getFieldByName(this._termsBoxFieldName);
    }
}

export = SearchBoxHeaderVue;